import { EventEmitter, Inject, Injectable } from '@angular/core';
import { AuthService } from '../../auth.service';
import { NotificationToastService } from '../../notification-toast.service';  
declare var $: any;

export enum MobileScannAction {
  scannOrder = 1,
  scannStudy = 2
}

export class MobileScannRequest {
  action: MobileScannAction;
  params?: string;
}


@Injectable({
    providedIn: 'root'
})
export class MobileScannService {
  
  public connectionExists = false;
  private proxy: any;
  private proxyName = 'mobileScannHub';
  private connection: any; 
  public imageReceive: EventEmitter<string>;


  constructor( @Inject('BASE_URL') private baseUrl: string,
               private authService: AuthService ) { 
  } 

  private registerOnServerEvents(): void {
    this.proxy.on('imageReceive', ( img ) => {
      this.imageReceive.emit(img);
    });
  }

  private startConnection(): Promise<boolean> {

    return new Promise((resolve, reject) => {

      this.connection = $.hubConnection(this.baseUrl);
      // create new proxy as name already given in top
      this.proxy = this.connection.createHubProxy(this.proxyName);
      // register on server events
      this.registerOnServerEvents();
      // call the connecion start method to start the connection to send and receive events.
  
      this.connection.start().done((data: any) => {
        this.connectionExists = true;  
        resolve(true); 
      }).fail((error: any) => {  
        this.connectionExists = false;
        reject(error);
      });

      this.connection.disconnected((data: any) => {
        console.log('LOG:::', 'disconnected');
        this.connectionExists = false;  
      }); 
    
    });
  }
   
  public async subscribe(request: MobileScannRequest)
  {
    const mobileLinkId = this.authService.getMobileLinkId(); 
    this.imageReceive =  new EventEmitter<string>(); 

    if (mobileLinkId == null)
      throw new Error('Debe cerrar sesión y volver a ingresar');
 
    if (!this.connectionExists)
      await this.startConnection(); 

    this.proxy.invoke('register', {
      mobileLinkId: this.authService.getMobileLinkId(),
      action: request.action,
      params: request.params
    });  

  }

  public unsubscribe(): void
  {
    if (this.connectionExists) {
      this.proxy.invoke('unregister', this.authService.getMobileLinkId()); 
    }
  }



}